export type BudgetReportRequest = {
  pageNumber: number;
  pageSize: number;
  filter: budgetFilter;
};

export type budgetFilter = {
  budgetYear: number;
  description: string;
  costCenter: string;
  glAccount: string;
  internalOrder: string;
};

export const GetReportBudget = async (req: BudgetReportRequest) => {
  const res = await fetch("api/Budget/GetReportBudget", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
  }).then((r) => r.json());
  return res;
};

export const GetReportBudgetSummaries = async (req: BudgetReportRequest) => {
  const res = await fetch("api/Budget/GetBudgetTrackingIOSummaries", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ Filter: req }),
  }).then((r) => r.json());
  return res;
};

export const GetReportBudgetFilter = async () => {
  const res = await fetch(`api/Budget/GetOptionReport`)
    .then((r) => r.json())
    .catch((e) => {
      return false;
    });
  return res;
};

export const GetPermissionReport = async (req: BudgetReportRequest) => {
  const res = await fetch(
    `api/Budget/GetPermissionReport?BudgetYear=${req.filter.budgetYear}`
  ).then((r) => r.json());
  return res;
};
